// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Callout-module--bx--text-truncate--end--XFqkp";
export var bxTextTruncateFront = "Callout-module--bx--text-truncate--front--hEBZm";
export var grid = "Callout-module--grid--YYN36";
export var row = "Callout-module--row--Df9NQ";
export var firstColumn = "Callout-module--firstColumn--UghgS";
export var secondColumn = "Callout-module--secondColumn--PWY7k";